<agpr-dialog-container
    [id]="id + '.confirmDialog'"
    [heading]="heading"
    [fitContent]="true"
    [closeOnClickOutside]="closeOnClickOutside"
    (close)="cancel()"
>
    <div
        [id]="id + '_confirmDialog_content'"
        class="agpr-confirmDialog-content"
        [ngClass]="{'agpr-confirmDialog-content--alertBelowMessage': alertBelowMessage}"
        [agprLoading]="loading"
        [ngStyle]="{
            width: width ? width + 'px' : '',
            maxWidth: maxWidth ? maxWidth + 'px' : '',
        }"
    >
        <agpr-scroll-panel [id]="id + '_confirmDialog_scrollPanel'">
            @if (contentTemplate) {
                <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
            }
            @if (alertMessage && !alertBelowMessage) {
                <ng-container
                    *ngTemplateOutlet="alertMessageTemplate; context: { alertMessage: alertMessage, alertType: alertType, alertMessageList: alertMessageList, alertId: id + '_confirmDialog_alert' }"
                ></ng-container>
            }
            @if (alertMessages) {
                @for (msg of alertMessages; track msg.alertMessage; let i = $index) {
                    <ng-container
                        *ngTemplateOutlet="alertMessageTemplate; context: { alertMessage: msg.alertMessage, alertType: msg.alertType, alertMessageList: msg.alertMessageList, alertId: id + '_confirmDialog_alert_' + i }"
                    ></ng-container>
                }
            }
            <ng-template
                #alertMessageTemplate
                let-alertMessage="alertMessage"
                let-alertType="alertType"
                let-alertMessageList="alertMessageList"
                let-alertId="alertId"
            >
                <agpr-message
                    [id]="alertId"
                    [severity]="alertType"
                >
                    {{ alertMessage | localize }}
                    @if (alertMessageList?.length > 0) {
                        <ul class="agpr-list">
                            @for (itemMessage of alertMessageList; track itemMessage) {
                                <li class="agpr-list-item">
                                    <span class="agpr-list-bullet fa fa-circle" aria-hidden="true"></span>
                                    {{ itemMessage }}
                                </li>
                            }
                    </ul>
                    }
                </agpr-message>
            </ng-template>

            @if (messageHtml) {
                <div
                    [id]="id + '_confirmDialog_message'"
                    [innerHTML]="(messageHtml | localize) | sanitizeHtml"
                ></div>
            } @else if (message) {
                <div
                    [id]="id + '_confirmDialog_message'"
                    [ngClass]="{ 'agpr-confirmDialog-messageBelowAlert': alertMessage }"
                >
                    {{ message | localize }}
                </div>
            }

            @if (alertMessage && alertBelowMessage) {
                <ng-container
                    *ngTemplateOutlet="alertMessageTemplate; context: { alertMessage: alertMessage, alertType: alertType, alertMessageList: alertMessageList, alertId: id + '_confirmDialog_alert' }"
                ></ng-container>
            }

            @if (list?.length > 0) {
                <div class="agpr-confirmDialog-list">
                    @if (listLabel) {
                        <agpr-checkbox
                            [id]="id + '_confirmDialog_list_checkbox'"
                            [binary]="true"
                            [label]="listLabel"
                            [(ngModel)]="isListSelected"
                            (onChange)="listSelectionChanged.emit($event)"
                        ></agpr-checkbox>
                    }
                    <agpr-scroll-panel class="agpr-confirmDialog-itemsScroll">
                        <ul
                            class="agpr-list"
                            [ngClass]="{
                                'agpr-list--indent': !!listLabel
                            }"
                        >
                            @for (item of list; track item) {
                                <li class="agpr-list-item">
                                    <span class="agpr-list-bullet fa fa-circle" aria-hidden="true"></span>
                                    {{ item }}
                                </li>
                            }
                        </ul>
                    </agpr-scroll-panel>
                </div>
            }

            @if (bottomMessage) {
                <div [ngClass]="{ 'agpr-confirmDialog-bottomMargin': bottomMargin }">
                    {{ bottomMessage | localize }}
                </div>
            }

            @if (disclaimerText) {
                <div class="agpr-confirmDialog-disclaimer">
                    <agpr-checkbox
                        [id]="id + '_confirmDialog_disclaimerCheckBox'"
                        [label]="disclaimerText | localize"
                        [binary]="true"
                        [(ngModel)]="disclaimerAccepted"
                    ></agpr-checkbox>
                </div>
            }
            @if (list?.length > 0 && secondaryList?.length > 0) {
                <div class="agpr-confirmDialog-divider"></div>
            }
            @if (secondaryList?.length > 0) {
                <div class="agpr-confirmDialog-list">
                    @if (secondaryListLabel) {
                        <agpr-checkbox
                            [id]="id + '_confirmDialog_secondaryList_checkbox'"
                            [binary]="true"
                            [label]="secondaryListLabel"
                            [(ngModel)]="isSecondaryListSelected"
                            (onChange)="secondaryListSelectionChanged.emit($event)"
                        ></agpr-checkbox>
                    }
                    <agpr-scroll-panel class="agpr-confirmDialog-itemsScroll">
                        <ul
                            class="agpr-list"
                            [ngClass]="{
                                'agpr-list--indent': !!secondaryListLabel
                            }"
                        >
                            @for (item of secondaryList; track item) {
                                <li class="agpr-list-item">
                                    <span class="agpr-list-bullet fa fa-circle" aria-hidden="true"></span>
                                    {{ item }}
                                </li>
                            }
                        </ul>
                    </agpr-scroll-panel>
                </div>
            }
        </agpr-scroll-panel>
    </div>

    <ng-template #footerLeft>
        @if (showCancel) {
            <agpr-button
                [id]="id + '_confirmDialog_cancel'"
                [label]="cancelLabel"
                [disabled]="loading"
                [style]="buttonTypes.secondary"
                (click)="cancel()"
            ></agpr-button>
        }

        @if (okLabelLeft) {
            <agpr-button
                [id]="id + '_confirmDialog_ok'"
                [label]="okLabel"
                [disabled]="loading || (!disclaimerAccepted && !!disclaimerText)"
                [style]="buttonTypes.primary"
                (click)="ok()"
            ></agpr-button>
        }
    </ng-template>

    <ng-template #footerRight>
        @if (!okLabelLeft) {
            <agpr-button
                [id]="id + '_confirmDialog_ok'"
                [label]="okLabel"
                [disabled]="loading
                    || (!disclaimerAccepted && !!disclaimerText)
                    || (!allowEmptyList && (list?.length === 0 || !isListSelected) && (secondaryList?.length === 0 || !isSecondaryListSelected))"
                [style]="buttonTypes.primary"
                (click)="ok()"
            ></agpr-button>
        }
    </ng-template>
</agpr-dialog-container>
